import { useEffect, useState } from 'react';
import { getUserProfile } from '@/services/authService';
import { useAuth } from '@/context/AuthContext';
import theme from '@/constants/theme';

export const ProfileHeader = () => {
  const [userData, setUserData] = useState<any>(null);
  const { token } = useAuth();
  const fullName = userData?.firstName + ' ' + userData?.lastName || '';
  const email = userData?.email || '';

  useEffect(() => {
    const fetchUser = async () => {
      if (token) {
        const user = await getUserProfile(token);
        setUserData(user);
      }
    };
    fetchUser();
  }, [token]);

  return (
    <div style={styles.container}>
      <img src={require('@/assets/images/profile.png')} style={styles.avatar} alt="avatar" />
      <div style={styles.detailContainer}>
        <p style={styles.name}>{fullName}</p>
        <span style={styles.email}>{email}</span>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    flexDirection: 'row',
    maxWidth: '100%',
  },
  avatar: {
    width: 80,
    aspectRatio: 1,
    borderRadius: 50,
  },
  detailContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    marginLeft: 4,
    maxWidth: '100%',
    overflow: 'hidden',
  },
  name: {
    fontSize: 20,
    fontWeight: 'bold',
    color: theme.colors.text.default,
    // text ellipsis
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
  email: {
    fontSize: 16,
    color: theme.colors.text.caption,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
  },
};